import { useLayoutEffect, useState } from 'react';

export const useUpdatedWindowSize = (): number[] => {
  const [windowSize, setWindowSize] = useState([0, 0]);

  // keep track of the window size to serve different markup based on screen size
  const updateWindowSize = () => {
    clearTimeout((updateWindowSize as any).timeout);
    (updateWindowSize as any).timeout = setTimeout(() => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    }, 100); // Debounce delay of 100ms
  };

  useLayoutEffect(() => {
    // call function to set window size initially
    updateWindowSize();

    // add event listener for setting the window size when the window is resized and on orientation change
    window.addEventListener('resize', updateWindowSize);
    window.addEventListener('orientationchange', updateWindowSize);

    // return a clean up function to remove the resize and orientationchange listener
    return () => {
      clearTimeout((updateWindowSize as any).timeout);
      window.removeEventListener('resize', updateWindowSize);
      window.removeEventListener('orientationchange', updateWindowSize);
    };
  }, []);
  return [windowSize[0], windowSize[1]];
};
